import { useDispatch } from "react-redux";
import { changeStream } from "features/streamLayout/layoutSlice";

const useDragNDrop = () => {
  const dispatch = useDispatch();

  const onDragOver = (ev: React.DragEvent) => {
    ev.preventDefault();
    const target = ev.target as Element;
    target.classList.add("dragover");
    ev.stopPropagation();
  };

  const onDragLeave = (ev: React.DragEvent) => {
    ev.preventDefault();
    const target = ev.target as Element;
    target.classList.remove("dragover");
    ev.stopPropagation();
  };

  const onDrop = (ev: React.DragEvent, index: number) => {
    ev.preventDefault();
    const target = ev.target as Element;
    target.classList.remove("dragover");
    var camName = ev.dataTransfer.getData("text/plain");
    var streamUpdate = {
      slot: index,
      stream: camName,
    };
    dispatch(changeStream(streamUpdate));
    ev.stopPropagation();
  };
  return { onDragOver, onDragLeave, onDrop };
};
export default useDragNDrop;
